module.exports = __webpack_public_path__ + "static/media/1POLICY27.33f04fa7.jpg";